import React from 'react';

const TinySpinner = (props) => {
    return (
        <div>
             <div className="loading-process">
        </div>
        <div className="tiny-loading-spinner-processing">
        
        </div>
        </div>
    )
}

export default TinySpinner;